export const MEETING_ATTENDANCE_ROLES = [
  'Administrator',
  'MeetingManager',
  'Leader',
  'Employee',
];

export const MEETING_MANAGEMENT_ROLES = [
  'Administrator',
  'MeetingManager',
];
